import React, { useEffect, useState } from "react";
import styles from "./PlatformFusion.module.scss";
import CountUp from "react-countup";
import {
  Button,
  Col,
  Input,
  Row,
  Typography,
  Image,
  TabsProps,
  Tabs,
} from "antd";
import PlatformFusionBg from "@assets/KPMG/Fusion.png";
import RightArrow from "@assets/KPMG/RightArrow.svg";
import { TabInfo } from "./TabInfo";
import { mockData } from "./mock";
import { Fade, Slide } from "react-awesome-reveal";

export const PlatformFusion = () => {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `Investment News`,
      children: <TabInfo type="investment" />,
    },
    {
      key: "2",
      label: `Marketplace News`,
      children: <TabInfo type="marketplace" />,
    },
    {
      key: "3",
      label: `Decarb Tools Hub News`,
      children: <TabInfo type="esg" />,
    },
  ];

  const [showCount, setShowCount] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      setShowCount(true);
    }, 1200);
  }, []);

  const { dashboard } = mockData;

  return (
    <>
      <div
        style={{
          position: "relative",
          height: "calc(100vh - 90px)",
          // opacity: 0.7,
        }}
      >
        <video
          controls={false}
          width="100%"
          height="100%"
          autoPlay
          muted
          loop
          style={{ objectFit: "none" }}
        >
          <source
            src="https://kpmgstorage001.blob.core.windows.net/kpmg/kpmg.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      <div className="platform-fusion" style={{ background: styles.white }}>
        <Fade triggerOnce direction="up">
          <div
            style={{
              maxWidth: 1000,
              margin: "0 auto",
              textAlign: "center",
              paddingTop: 20,
              background: "#0C233C",
              borderRadius: 10,
              padding: "20px 40px",
              marginTop: -80,
              marginBottom: 40,
            }}
          >
            <div style={{ display: "flex", marginBottom: 20 }}>
              <Input placeholder="Type your keyword" style={{ height: 40 }} />
              <Button
                type="primary"
                className="btn-primary"
                style={{
                  height: 40,
                  borderRadius: "24 !important",
                  marginLeft: -40,
                  minWidth: 100,
                }}
              >
                SEARCH
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                // marginBottom: 40,
              }}
            >
              <Button
                type="default"
                style={{
                  background: "transparent",
                  color: "#fff",
                }}
              >
                Taxations
              </Button>
              <Button
                type="default"
                style={{
                  background: "transparent",
                  color: "#fff",
                }}
              >
                Investors
              </Button>
              <Button
                type="default"
                style={{
                  background: "transparent",
                  color: "#fff",
                }}
              >
                Policies
              </Button>
              <Button
                type="default"
                style={{
                  background: "transparent",
                  color: "#fff",
                }}
              >
                Investments
              </Button>
              <Button
                type="default"
                style={{
                  background: "transparent",
                  color: "#fff",
                }}
              >
                New Projects
              </Button>
              <Button
                type="default"
                style={{
                  background: "transparent",
                  color: "#fff",
                }}
              >
                Innovations
              </Button>
              <Button
                type="default"
                style={{
                  background: "transparent",
                  color: "#fff",
                }}
              >
                Budgets
              </Button>
            </div>
          </div>
        </Fade>
        <div style={{ marginTop: 20 }}>
          <Row gutter={[32, 16]}>
            <Col md={10}>
              <Slide direction="left" triggerOnce>
                <Image src={PlatformFusionBg} preview={false} />
              </Slide>
            </Col>
            <Col md={14}>
              <Slide direction="right" triggerOnce>
                <div className="dashboard-container">
                  <Row
                    style={{ padding: "20px 30px" }}
                    className="dashboard-items"
                  >
                    {dashboard &&
                      dashboard.map((item: any, index: number) => {
                        return (
                          <Col span={6} key={index}>
                            {item.count && (
                              <div style={{ padding: "20px 10px" }}>
                                <Typography.Title
                                  level={2}
                                  style={{
                                    color: styles.white,
                                    marginBottom: 0,
                                  }}
                                >
                                  {item.prefix}
                                  {showCount && (
                                    <span>
                                      <CountUp end={item.count} />
                                      {item.suffix}
                                    </span>
                                  )}
                                </Typography.Title>
                                <Typography.Text
                                  style={{ color: styles.white }}
                                >
                                  {item.value}
                                </Typography.Text>
                              </div>
                            )}
                          </Col>
                        );
                      })}
                  </Row>
                </div>
              </Slide>
              <Fade direction="up" triggerOnce>
                <div style={{ paddingTop: 10 }}>
                  <Row>
                    <Col md={20} sm={6}>
                      <div className="flex-center">
                        <Typography.Title level={3} className="clr-secondary">
                          Latest News
                        </Typography.Title>
                        <Typography.Link>
                          View All <Image src={RightArrow} preview={false} />
                        </Typography.Link>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div style={{ marginTop: 0 }}>
                  <Tabs defaultActiveKey="1" items={items} />
                </div>
              </Fade>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
